import React, { Component, Fragment } from "react";
import {FormattedMessage} from "react-intl";
import NumberFormatter from "../../../../Common/NumberFormatter/NumberFormatter";
import ViewItemDetails from "../../../../Admin/Order/ViewSingleCustomerOrder/ViewItemDetails/ViewItemDetails";
import ReactGA from "react-ga";
import {GOOGLE_ANALYTICS_CODE} from "../../../../../configuration";

class ViewSingleCustomerOrderResponsive extends Component {
    render() {
        ReactGA.initialize(GOOGLE_ANALYTICS_CODE);
        ReactGA.pageview(window.location.pathname + window.location.search);
        return(
            <Fragment>
                {this.props.orderData.map(item => {

                    let pcbParams ={};
                    let stencilParams ={};
                    let dimensions = "";

                    if(item.quotation.orderType === 1){
                        pcbParams = item.quotation.pcbParam;
                        dimensions = pcbParams.width !== '' && pcbParams.length !== '' ?
                            pcbParams.width + "*" + pcbParams.length + "" : '';
                    }
                    else if(item.quotation.orderType === 2){
                        pcbParams = item.quotation.pcbParam;
                        stencilParams = item.quotation.stencilParam;
                        dimensions = pcbParams.width !== '' && pcbParams.length !== '' ?
                            pcbParams.width + "*" + pcbParams.length + "" : '';
                    }
                    else {
                        stencilParams = item.quotation.stencilParam;
                    }

                    return (
                        <div className="">
                            <div className="single-item-heading">
                                {item.itemName}
                            </div>
                            <div className="custom-col-4">
                                <img src={item.imageUrlFrontEncoded} alt="Item Image" className="single-order-image-responsive"/>
                            </div>
                            <div className="custom-col-8 resp-single-item-info-div">
                               <div className="resp-single-order-info-row">
                                   <FormattedMessage id="app.admin.view.single.order.quantity"
                                                     defaultMessage="Qty"
                                                     description=""/> :

                                   <span>

                            {item.quotation.orderType === 1 &&
                            pcbParams.qty
                            }
                                       {item.quotation.orderType === 2 &&
                                       pcbParams.qty},{stencilParams.stencilQty}

                                       {item.quotation.orderType === 3 &&
                                       stencilParams.stencilQty
                                       }

                        </span>

                               </div>
                               <div className="resp-single-order-info-row unit-price-responsive">
                                   <FormattedMessage id="app.admin.view.single.order.total"
                                                     defaultMessage="Item Cost"
                                                     description=""/>(¥) :

                                   <NumberFormatter num={item.unitPrice}/>

                               </div>
                               <div className="resp-single-order-info-row">
                                   <FormattedMessage id="app.admin.view.single.order.weight"
                                                     defaultMessage="Weight"
                                                     description=""/>(g) :
                                   <NumberFormatter num={item.chargeDetails.weight}/>g

                               </div>
                               <div className="resp-single-order-info-row">
                                   <ViewItemDetails orderType={item.quotation.orderType}
                                                    itemDetails={item}/>

                               </div>
                            </div>

                        </div>
                    );
                })}

            </Fragment>
        );
    }

}
export default ViewSingleCustomerOrderResponsive;


// WEBPACK FOOTER //
// ./src/components/Site/Order/SingleOrder/ViewSingleCustomerOrder/ViewSingleCustomerOrderResponsive.js